import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NavVertical from './NavVertical';
import AnyePote2 from './icons/AnyePote2';
import AnyeMosca2 from './icons/AnyeMosca2';
import AnyeMosquito2 from './icons/AnyeMosquito2';
import AnyeVistasBarco1 from './icons/AnyeVistasBarco1';
import AnyeVistasBarco3 from './icons/AnyeVistasBarco3';
import AnyeVistasBarco4 from './icons/AnyeVistasBarco4';
import VisitorRegistrationIcon from './icons/VisitorRegistrationIcon';
import AnyeCandado from './icons/AnyeCandado';
import AnyeGrillete from './icons/AnyeGrillete';
import AnyeEsposas from './icons/AnyeEsposas';
import BarcoVolteado from './icons/BarcoVolteado';

const navIcons = [
  { icon: AnyePote2, to: '/Gispert2', label: 'nav.gispert2', top: '10%', left: '10%' },
  { icon: AnyeMosca2, to: '/Gispert6', label: 'nav.gispert6', top: '30%', right: '12%' },
  { icon: AnyeMosquito2, to: '/Gispert5', label: 'nav.gispert5', top: '48%', right: '20%' },
  { icon: AnyeEsposas, to: '/Gispert1', label: 'nav.gispert1', top: '87%', left: '12%' },
  { icon: AnyeGrillete, to: '/Gispert3', label: 'nav.gispert3', top: '54%', left: '8%' },
  { icon: AnyeVistasBarco4, to: '/Gispert4', label: 'nav.gispert4', top: '62%', right: '12%' },
  { icon: AnyeVistasBarco1, to: '/Museo1', label: 'nav.museo1', top: '36%', left: '15%' },
  { icon: AnyeVistasBarco3, to: '/Museo2', label: 'nav.museo2', top: '6%', right: '14%' },
  { icon: BarcoVolteado, to: '/Introduccion', label: 'nav.introduccion', top: '74%', left: '14%' },
  { icon: AnyeCandado, to: '/Instructivo', label: 'nav.instructivo', top: '62%', left: '6%' },
  { icon: VisitorRegistrationIcon, to: '/VisitorRegistration', label: 'nav.newsletter', top: '88%', right: '15%' },
];

const DELAY_MS = 3000;

const FloatingNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [iconsVisible, setIconsVisible] = useState(false);
  const mountedAtRef = useRef(Date.now());
  const listenerRef = useRef(null);

  useEffect(() => {
    setIconsVisible(false);
    mountedAtRef.current = Date.now();

    const handleMove = () => {
      if (Date.now() - mountedAtRef.current < DELAY_MS) return;
      setIconsVisible(true);
      if (listenerRef.current) {
        document.removeEventListener('mousemove', listenerRef.current);
        listenerRef.current = null;
      }
    };

    listenerRef.current = handleMove;
    document.addEventListener('mousemove', handleMove);
    return () => {
      document.removeEventListener('mousemove', handleMove);
      listenerRef.current = null;
    };
  }, [location.pathname]);

  return (
    <nav className={`FloatingNav${iconsVisible ? ' FloatingNav--iconsVisible' : ''}`} aria-label="Navegación">
      <NavVertical />

      {navIcons.map(({ icon: Icon, to, label, top, left, right }, i) => {
        const isLink = !!to;
        const tooltipText = label ? t(label) : null;
        const baseClass = 'HomeHero-navIcon';
        const modClass = isLink ? 'HomeHero-navIcon--link' : 'HomeHero-navIcon--deco';
        const style = { top, ...(left != null ? { left } : {}), ...(right != null ? { right } : {}) };

        if (isLink) {
          return (
            <Link
              key={i}
              to={to}
              className={`${baseClass} ${modClass}`}
              style={style}
              data-tooltip={tooltipText}
            >
              <Icon />
            </Link>
          );
        }
        return (
          <span key={i} className={`${baseClass} ${modClass}`} style={style}>
            <Icon />
          </span>
        );
      })}
    </nav>
  );
};

export default FloatingNav;
